import { render } from "./quoteCard.vue?vue&type=template&id=1b4ac9f1&scoped=true"
import script from "./quoteCard.vue?vue&type=script&lang=js"
export * from "./quoteCard.vue?vue&type=script&lang=js"

import "./quoteCard.vue?vue&type=style&index=0&id=1b4ac9f1&lang=less&scoped=true"

import exportComponent from "F:\\LSDC\\trunk\\lsdc-delivery-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b4ac9f1"]])

export default __exports__